"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import EmployeeCard from "../ui/EmployeeCard";
import { motion, useAnimation } from "framer-motion";
import { formatPhoneNumber, getDefaultCmsSection } from "@/utils/helper";
import Card from "../ui/Card";

const EmployeesSectionComponent: React.FC<{
  resourceGroup: any;
  cmsSection: any;
}> = ({ cmsSection, resourceGroup }) => {
  const controls = useAnimation();

  const employeeImageAspectRatio = (cmsSection?.ui as any)
    ?.employeeImageAspectRatio;

  if ((resourceGroup.websiteEmployees?.length ?? 0) === 0) {
    return null;
  }

  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "xl",
      })}
    >
      <div className="flex flex-col gap-2 ">
        <div
          style={{ color: cmsSection?.specifics?.textColor }}
          className="homepage-text-xl"
        >
          Medarbejdere
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {(resourceGroup.websiteEmployees ?? [])
            .map((wb: any) => {
              const c = {
                ...wb,
                employee: {
                  ...wb.employee,
                  email: wb.employee?.contact?.email?.address,
                  phone: {
                    number: formatPhoneNumber(
                      wb.employee?.contact?.phone?.prefix ?? "",
                      wb.employee?.contact?.phone?.number ?? ""
                    ),
                    isMobile: false,
                  },
                },
              };
              return c;
            })
            .sort((a: any, b: any) => (a.position > b.position ? 1 : -1))
            .map(
              (data: {
                employee: {
                  id: string;
                  displayName: string;
                  jobTitle: string;
                  image?: {
                    mdUrl: string;
                  };
                  email: string;
                  phone: {
                    number: string;
                    isMobile: boolean;
                  };
                };
                position: string;
              }) => (
                <motion.div
                  key={data.employee.id}
                  initial="initial"
                  whileInView="animate"
                  animate={controls}
                  viewport={{
                    once: true,
                  }}
                  variants={{
                    initial: {
                      opacity: 0,
                      y: 100,
                    },
                    animate: {
                      opacity: 1,
                      y: 0,
                      transition: {
                        delay: 0.05,
                      },
                    },
                  }}
                >
                  <Card className="h-full">
                    <EmployeeCard
                      employee={{
                        ...data.employee,
                        image: {
                          ...data.employee.image,
                          aspectRatio: employeeImageAspectRatio,
                        },
                      }}
                    />
                  </Card>
                </motion.div>
              )
            )}
        </div>
      </div>
    </SectionLayout>
  );
};

export default EmployeesSectionComponent;
